import axios from 'axios'

const instance = axios.create({
  // baseURL: 'https://testmengjiapi.mengqin.vip', // test
  // baseURL: 'http://192.168.10.10:9501', // dev
  baseURL: 'https://jigongapi.mengqin.vip', // prod
  timeout: 6000 // 请求超时时间
});

// export const ACCESS_TOKEN = 'Access-Token'

// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 拦截请求
// instance.interceptors.request.use(config => {
//   const timestamp = Date.parse(new Date().toISOString())
//   const uuid = getUuid()
//
//   config.headers['X-Ca-Timestamp'] = timestamp
//   config.headers['X-Ca-Nonce'] = uuid
//   config.headers['X-Ca-Signature'] = getSign(timestamp, uuid)
//
//   return config
// }, error => {
//   return Promise.reject(error)
// })
//
// // 拦截响应
// instance.interceptors.response.use(response => {
//   if (response.data.code > 0) {
//     return Promise.reject()
//   }
//
//   return Promise.resolve(response.data.data)
// }, error => {
//
//   return Promise.reject(error)
// })

export const get = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: 'get',
      url,
      params,
      ...config
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

/* 统一封装post请求  */
export const post = (url, data, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url,
      data,
      ...config
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

